<template>
  <el-card>
    <div class="weekquery">
      <div class="weekquery-title" :class="item.alltime==currentDate?'current':''" v-for="(item,index) in weekList" :key="index" @click="addReserve(item.date)">
        {{item.time}}({{item.day}})
      </div>
      <div class="content" v-for="(item,index) in weekList"  :key="'key'+index">
        <div :class="'order'+itm.orderState" v-for="(itm,idx) in item.list" :key="itm.id" @click="editReserve(itm)">
          <div class="flex-n fac">
            <div class="font-xi"   @click.stop="changeWedding(itm.id, itm.weddingId, itm.hasWedding) " :class="itm.hasWedding=='0'?'':'font-xi-success'" v-if="itm.isWedding=='1'"></div>
            <div class="info-title">
              {{itm.houseName}}
            </div>
            <div class="info-name oneline">{{itm.hasWedding=='1'?(itm.femaleName+'、'+itm.maleName):itm.customName}}</div>
          </div>
          <div class="flex-n fac">
            <i class="el-icon-time"></i>
            <div style="margin-left: 5px;font-size: 12px">{{itm.labelText}}</div>
          </div>
            <div class="flex-n fac">
              <i class="el-icon-date"></i>
              <div style="margin-left: 5px;font-size: 12px">{{itm.packageName}}[{{itm.ordertype}}]</div>
            </div>
            <div class="flex-n fac">
              <i class="el-icon-user"></i>
              <div style="margin-left: 5px;font-size: 12px">{{itm.createUserName}}</div>
            </div>
          <i class="copy el-icon-document-copy"
             @click.stop="copyInfo(itm.id)"></i>
        </div>
      </div>


    </div>
    <!--预定-->
    <books :id="id" ref="books" :visible.sync="booksDialog"  @refresh="refresh"></books>
    <!--查看预订-->
    <view-book :id="id" :visible.sync="lookOrder"></view-book>
    <!--编辑婚庆-->
    <edit-wedding :id="id" :wed-id="wedId" :visible.sync="showWeddingDialog" :type="wedState"
                  @refresh="refresh"></edit-wedding>
  </el-card>
</template>

<script>
  import Books from "../../component/books";
  import ViewBook from "./ViewBook";
  import EditWedding from "./EditWedding";

  export default {
    components: {
      EditWedding,
      ViewBook,
      Books},
    name: "week-query",
    props: {},
    data() {
      return {
        weekList: [],
        currentDate: '',

        id:'',//订单id
        booksDialog: false, //预订弹窗

        lookOrder: false, //查看预订

        wedState: 0, //婚庆数据状态
        showWeddingDialog: false, //婚庆弹窗
        wedId: '',
        isDisplayPrein:'1',
        timeTagList:[],
        tagList:[]
      }
    },
    watch: {},
    mounted() {
      this.getTimeRange();
    },
    methods: {
      getTimeRange() {
        this.$axios.get('/config/baseByStoreId/' + this.$root.getStorage('storeId')).then(res => {
          console.log('基本店铺设置信息', res.data)
          let orderTag = [];
          for (let i in res.data.orderTag) {
            orderTag.push(res.data.orderTag[i].beginTime + '~' + res.data.orderTag[i].endTime)
          }
          this.timeTagList = orderTag;
          this.tagList = res.data.orderTag;
        }).catch(err => {
          this.$message.error(err.msg);
        })
      },
      getCalendar(beginDate, endDate, houseTypeIds) {
        console.log(beginDate, houseTypeIds)
        let t1 = new Date(beginDate).getTime();
        let t2 = new Date(endDate).getTime();
        let weekList = [], day = ['一', '二', '三', '四', '五', '六', '日'], pos = 0;
        this.currentDate = this.$TM.setTextData(new Date().getTime());
        for (let i = t1; i <= t2; i = i + 24 * 60 * 60 * 1000) {
          weekList.push({
            time: this.$TM.setTextData2(i),
            alltime: this.$TM.setTextData(i),
            date:this.$TM.getDate(i),
            day: '周' + day[pos],
            list:[]
          })
          pos++;
        }
        this.weekList = weekList;
        this.houseTypeIds = houseTypeIds;
        this.getWeekOrders(beginDate,endDate,houseTypeIds);
      },
      //周订单数据列表
      getWeekOrders(startTime,endTime,houseTypeIds) {
        this.$axios.post('/order/orderCalendarWeekOrders', {
          "startTime": startTime,
          "endTime": endTime,
          "houseTypeIds": houseTypeIds,
          "storeId": this.$root.getStorage('storeId')
        }).then(res => {
          console.log('周订单数据列表', res)

          for(var i in res.data.list){
            var ordertype = '', content = '';
            let item = res.data.list[i];

            let idx = this.timeTagList.indexOf(item.activityBeginTime + '~' + item.activityEndTime);

            let labelText = idx > -1 ? this.tagList[idx].tagName : ((item.activityBeginTime == item.activityBeginTimeReal ? item.activityBeginTime : ('次日' + item.activityBeginTimeReal)) + '~' + (item.activityEndTime == item.activityEndTimeReal ? item.activityEndTime : ('次日' + item.activityEndTimeReal)));
            res.data.list[i].labelText = labelText;

            for (var l in res.data.list[i].payTypes) {
              if (res.data.list[i].payTypes[l].payTypeCode == '01') {
                if (res.data.list[i].payTypes[l].orderCount)
                  content += res.data.list[i].payTypes[l].orderCount + '人、';
              }
              if (res.data.list[i].payTypes[l].payTypeCode == '02') {
                if (res.data.list[i].payTypes[l].orderCount)
                  content += res.data.list[i].payTypes[l].orderCount + '桌、';
              }
            }
            if (content.length > 0)
              content = content.substring(0, content.length - 1)
            if (res.data.list[i].mainPayType == '03') {
              if (content.length > 0)
                ordertype = '包场(' + content + ')';
              else {
                ordertype = '包场';
              }
            } else {
              ordertype = content;
            }
            res.data.list[i].ordertype = ordertype;

            for(var j in this.weekList){
              if(this.weekList[j].date==res.data.list[i].orderDate){
                this.weekList[j].list.push(res.data.list[i]);
                break;
              }
            }
          }
          console.log(this.weekList)
        }).catch(err=>{

        })
      },
      //新增预订
      addReserve(date) {
        this.id='';
        if (date){
          this.$refs.books.dataForm.orderDate=date;
        }
        this.booksDialog = true;
      },
      //编辑预定
      editReserve(data) {
        console.log(data)
        this.id = data.id;
        if(data.confirmState!='01'&&((this.$root.getStorage('menuAuth').isEditOther==0&&(this.$root.getStorage('info').userId==data.createUserCode))||this.$root.getStorage('menuAuth').isEditOther==1)){
          this.booksDialog = true;
        }else{
          return this.lookOrder=true;
        }
      },
      changeWedding(id, wedid, data) {
        this.id = id;
        this.wedId = wedid;
        this.showWeddingDialog = true;
        this.wedState=data;
      },
      copyInfo(id) {
        this.$emit('copyInfo', id);
      },
      //todo 刷新列表 ，新建在哪天 刷新到哪天
      refresh(orderDate){
        this.$emit('chooseDate',orderDate);
      },
    }
  }
</script>

<style scoped lang="scss">
  .weekquery {
    height: calc(100vh - 250px);
    display: grid;
    grid-gap: 1px;
    border: 1px solid #f1f1f1;
    background: #f1f1f1;
    grid-template-columns: repeat(7, minmax(100px, 1fr));
    grid-template-rows: 30px 1fr;
    > div {
      background: white;
    }

    .weekquery-title {
      padding: 0;
      background: #d2e6fe;
      line-height: 30px;
      font-weight: bold;
      text-align: center;
      cursor: pointer;
      &.current {
        color: #5295e7;
      }
    }
    .content {
      >div {
        padding:5px;
        cursor: pointer;
        line-height: 24px!important;
        margin: 5px;
        border-radius: 4px;
        position: relative;
        .font-xi {
          width: 14px;
          height: 14px;
          min-width: 14px;
          margin-right: 2px;
          border: 1px solid #666666;
          background: #eeeeee;
          transform: rotate(45deg);
          transform-origin: center center;
          position:relative;
          font-weight: lighter;
          &::before{
            display: block;
            content:'喜';
            position: absolute;
            left: 1px;
            top: -4px;
            font-size: 12px;
            transform: rotate(-45deg);
          }
        }
        .font-xi-success{
          border: 1px solid #ff3918;
          background: #eed4d5;
          color: #ff3918;
        }
        .el-icon-document-copy{
          cursor: pointer;
        }
        .copy {
          position: absolute;
          top: 5px;
          right: 5px;
          z-index: 100;
        }
        &.order01 {
          background: #D8C9FC;
          border: 1px solid #dabdee !important;
        }
        &.order02 {
          background: #D0E5FF;
          border: 1px solid #bdd0ee !important;
        }
        &.order03 {
          background: #e6e6e6;
          border: 1px solid #e6e6e6 !important;
        }
        &:hover{
          box-shadow: 0 0 10px 1px #eeeeee;
        }
        .info-title{
          white-space: nowrap;
          font-weight: bold;
          font-size: 14px;
          margin-left: 5px;
        }
        .info-name{
          font-size: 12px;
          margin-left: 5px;
        }
      }

    }
  }
</style>
